import { getIconProps, type IconProps } from '#types'

/**
 * Filter icon — funnel with horizontal divider.
 *
 * Used for filter buttons, filter panels, and data-filtering controls.
 *
 * @example
 * ```tsx
 * <button>
 *   <FilterIcon className="h-4 w-4" /> Filter
 * </button>
 * ```
 */
export function FilterIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M7.50293 4H17.4971C18.6645 4.00008 19.4882 5.46474 18.6836 6.58301L14.5195 12.3711C14.1792 12.8442 13.9981 13.4144 13.998 13.9961V17.8135C13.998 17.9981 13.9767 18.0721 13.9648 18.1016C13.9574 18.1199 13.9377 18.1635 13.8438 18.2451L13.8301 18.2578L12.0742 19.8408C11.859 20.0261 11.6141 20.0393 11.3994 19.9346C11.1797 19.8273 11.0021 19.597 11.002 19.2607V13.9961C11.0019 13.4144 10.8208 12.8442 10.4805 12.3711L6.31641 6.58301C5.51183 5.46474 6.33546 4.00008 7.50293 4Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7H13"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
